import { FC, memo } from 'react';

import { FormField, LoadingField } from '~/core/shared/components';
import { useFormFieldBlockRenderer } from './hooks/useFormFieldBlockRenderer';
import { FormFieldBlockRendererProps } from './types/FormFieldBlockRendererProps';

const FormFieldBlockRendererComponent: FC<FormFieldBlockRendererProps> = ({
  block,
  namePrefixes,
}) => {
  const { isLoadingAsyncProps, ...props } = useFormFieldBlockRenderer(
    block,
    namePrefixes,
  );

  if (isLoadingAsyncProps) {
    return <LoadingField />;
  }

  return <FormField {...props} />;
};

export const FormFieldBlockRenderer = memo(FormFieldBlockRendererComponent);
